import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useExpenditureListStore } from "../../../../Store/CashControlStore/ExpenditureListStore";

const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: "400",
  }),
  control: (provided) => ({
    ...provided,
    height: "37px",
    minHeight: "37px",
    width: "200px",
    fontSize: "13px",
    fontFamily: "Inter",
    fontWeight: "400",
  }),
};

export default function Selector({ param, property }) {
  const { updateParams, loadItems, queryParams, setLoading } =
    useExpenditureListStore();

  const options = useMemo(() => {
    return (
      param?.map((element) => ({
        label: element.name,
        value: element.id,
      })) || []
    );
  }, [param]);
  const { t } = useTranslation();
  const handleSelectChange = useCallback(async (e) => {
    setLoading(true);
    if (property === t("O'qituvchilar")) {
      updateParams({
        reasonponsible_staff: e?.value == undefined ? "" : e?.value,
        page: 1,
      });
      await loadItems(
        new URLSearchParams({
          ...queryParams,
          reasonponsible_staff: e?.value == undefined ? "" : e?.value,
          page: 1,
        }).toString()
      );
    }
    if (property === t("Filiallar")) {
      updateParams({ branch: e?.value == undefined ? "" : e?.value, page: 1 });
      await loadItems(
        new URLSearchParams({
          ...queryParams,
          branch: e?.value == undefined ? "" : e?.value,
          page: 1,
        }).toString()
      );
    }
    if (property === t("Harajat turlari")) {
      updateParams({
        expenditures_list: e?.value == undefined ? "" : e?.value,
        page: 1,
      });
      await loadItems(
        new URLSearchParams({
          ...queryParams,
          expenditures_list: e?.value == undefined ? "" : e?.value,
          page: 1,
        }).toString()
      );
    }
    setLoading(false);
  });

  return (
    <div className="normal-select-bar">
      <Select
        className="basic-single manage_group_select"
        classNamePrefix="select"
        placeholder={property}
        styles={customStyles}
        options={options}
        isClearable
        onChange={handleSelectChange}
      />
    </div>
  );
}
